<template>
  <div class="eaAreaMultiple">
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item name="1">
        <template slot="title">
          <el-select
            v-model="slevalue"
            multiple
            placeholder="请选择"
            disabled
            @click.native="showColl"
          >
            <el-option
              v-for="item in chooseNode"
              :key="item.CantonCode"
              :label="item.CantonName"
              :value="item.CantonCode"
            ></el-option>
          </el-select>
        </template>
        <el-card class="box-card">
          <el-tree
            ref="tree"
            :data="data"
            show-checkbox
            node-key="CantonCode"
            :default-expanded-keys="[division]"
            :props="defaultProps"
            @check-change="getNode()"
          ></el-tree>
        </el-card>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { CantonMgeSvr } from '@/service/CantonMgeSvr';
import { mapState } from 'vuex';
import { division } from '@/assets/js/division';
import debounceOrThrottle from '@/utils/debounceOrThrottle';
export default {
  components: {},
  props: ['value'],
  data() {
    return {
      data: [],
      defaultProps: {
        children: 'Childs',
        label: 'CantonName',
        value: 'CantonCode'
      },
      division: division,
      chooseNode: [],
      slevalue: [],
      activeName: null
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.cantonMgeSvr = new CantonMgeSvr();
  },
  mounted() {
    this.cantonMgeSvr.GetCanton(this.token, division, true).then(res => {
      res.Childs = this.dealOption(res.Childs._Items);
      this.data = [res];
    });
    this.getNode = debounceOrThrottle.throttle(() => {
      this.chooseNode = this.$refs.tree.getCheckedNodes();
      this.$emit('input', this.chooseNode);
      this.slevalue = this.chooseNode.map(item => {
        return item.CantonName;
      });
    });
  },
  methods: {
    dealOption(option) {
      for (let i = 0; i < option.length; i++) {
        if (option[i].Childs._Items.length > 0) {
          option[i].Childs = option[i].Childs._Items;
          if (option[i].Childs.length > 0) {
            this.dealOption(option[i].Childs);
          }
        } else {
          option[i].Childs = null;
        }
      }
      return option;
    },
    handleCheckChange(data) {
      this.getNode()();
      // this.value.push(data.CantonName);
    },
    getNode() {},
    showColl() {
      this.activeName = this.activeName === '1' ? null : '1';
    }
  }
};
</script>
<style lang="scss" >
.eaAreaMultiple {
  .el-collapse-item__header {
    width: 100%;
    border: none;
  }
  .el-collapse {
    border: none;
    .el-collapse-item {
      .el-collapse-item__arrow {
        display: none;
      }
      .el-collapse-item__content {
        padding-bottom: 0;
      }
    }
  }
  .box-card {
    height: 300px;
    overflow: auto;
  }
  .el-select {
    .is-disabled {
      cursor: pointer;
      input {
        background: inherit;
        color: inherit;
      }
      .el-input__inner {
        cursor: pointer;
      }
    }
    .el-select__tags {
      height: 100%;
      line-height: 1;
      overflow: hidden;
      top: 58%;
    }
    .el-tag {
      margin: 8px 6px;
    }
  }
}
</style>